<div
  class="relative w-[300px] h-[365px] p-[20px] shadow-[0_4px_12px_0px_#14192D29] cursor-pointer border-solid"
  [class.border-[2px]]="item?.isModerated"
  [class.border-[#e5cc6f]]="item?.isModerated"
  [class.bg-[#fff8e0]]="item?.isModerated"
  [class.bg-white]="!item?.isModerated"
>
  <div
    *ngIf="item?.isFlagged && !isIdea"
    class="absolute top-0 left-0 right-0 bottom-0 z-[10] backdrop-blur-[5px] flex items-center justify-center"
  >
    <div class="flex flex-col items-center">
      <ark-lib-icon-name name="flagged"></ark-lib-icon-name>
      <div class="w-full bg-pink-600 mt-[18px] px-2 py-1">
        <div
          class="text-center text-white text-[11px] font-bold uppercase leading-[18px] tracking-wide"
        >
          Reported as illegal content
        </div>
      </div>
    </div>
  </div>

  <div [class.opacity-40]="item?.isFlagged">
    <div class="w-full h-full flex flex-col" (click)="onCardClick()">
      <div class="flex flex-col flex-1">
        <img
          class="w-full h-[80px] rounded object-cover"
          [src]="(item?.images | first)?.image ?? '/assets/shared/images/placeholder-image.png'"
        />
        <div class="mt-[5px] flex items-center justify-between uppercase text-[11px]">
          <div class="font-bold">{{ typeLabel }}</div>
          <div class="text-[#BEB9B4] font-semibold" *ngIf="!item?.isDraft && identifier">
            #{{ identifier }}
          </div>
        </div>

        <div
          class="text-black text-lg font-bold leading-6 mt-[10px] h-[48px] min-h-[48px] shrink-0 line-clamp-2"
        >
          {{ item?.title }}
        </div>

        <div
          class="mt-[10px] mb-[5px] h-[72px] min-h-[72px] shrink-0"
        >
          <div
            class="text-black text-sm leading-[18px] h-[54px] max-h-[54px] overflow-hidden line-clamp-3 [&_*]:!m-0 [&_*]:!leading-[18px]"
            [innerHTML]="contentText"
          ></div>
        </div>
      </div>

      <div class="flex items-center py-1">
        <div
          class="w-full h-[3px] bg-[#E6E1D7]"
          [class.mb-[5px]]="!item?.isModerated"
          [class.bg-[#e5cc6f]]="item?.isModerated"
          [class.flex-[1]]="item?.isModerated"
        ></div>
        <div class="pl-[5px]" *ngIf="item?.isModerated">
          <div
            class="flex items-center text-stone-400 text-[11px] font-bold uppercase leading-[18px] tracking-wide w-max"
          >
            <div class="text-[#e5cc6f]">
              {{ moderationText }}
            </div>
          </div>
        </div>
      </div>

      <div class="flex flex-row items-center justify-between gap-[10px]">
        <div class="flex flex-row items-center justify-start gap-[5px] min-w-0">
          <div
            class="text-left text-black text-[11px] font-medium leading-[18px] cursor-pointer"
            (click)="onNicknameClick($event)"
          >
            by {{ '@' + item?.creatorNickname }}
          </div>
          <ark-lib-pi-badge
            [userIndex]="item?.userIndex"
            [userIndexDiff]="item?.userIndexDetails?.userIndexDiff"
            [userIndexAmbassador]="item?.userIndexDetails?.userIndexAmbassador"
            [userIndexCreator]="item?.userIndexDetails?.userIndexCreator"
            [userIndexHelper]="item?.userIndexDetails?.userIndexHelper"
            [clickable]="true"
          ></ark-lib-pi-badge>
        </div>
        <div class="shrink-0">
          <ark-lib-wisee [marketSectors]="item?.marketSectors"></ark-lib-wisee>
        </div>
      </div>

      <div class="flex-1 min-h-[20px]" *ngIf="!isIdea && !isProblem"></div>

      <div class="flex-1 min-h-[10px]" *ngIf="isIdea || isProblem"></div>

      <div class="justify-start items-center gap-3 flex pt-[5px]" *ngIf="!isIdea && !isProblem">
        <div class="justify-between items-baseline gap-2.5 flex w-full">
          <div class="justify-center items-center gap-[3px] flex">
            <ark-lib-icon-name name="heart"></ark-lib-icon-name>
            <div class="text-black text-xs font-normal leading-tight">
              {{ item?.subscriberCount }}
            </div>
          </div>
          <div class="justify-center items-center gap-[3px] flex" *ngIf="item?.backedCount != null">
            <ark-lib-icon-name name="backing"></ark-lib-icon-name>
            <div class="text-black text-xs font-normal leading-tight">
              {{ item?.backedCount }}
            </div>
          </div>
          <div class="justify-center items-center gap-[3px] flex">
            <ark-lib-icon-name name="stats-star"></ark-lib-icon-name>
            <div class="text-black text-xs font-normal leading-tight">
              {{ item?.rating | number:'1.0-2' }}
            </div>
            <div
              class="font-normal text-[10px] leading-[18px] text-black self-start"
            >
              ({{ item?.ratingCount }})
            </div>
          </div>
          <div class="justify-center items-center gap-[3px] flex">
            <ark-lib-icon-name name="chat"></ark-lib-icon-name>
            <div class="text-black text-xs font-normal leading-tight">
              {{ item?.commentCount }}
            </div>
          </div>
          <div class="flex flex-row items-center" *ngIf="item?.shareCount != null">
            <ark-lib-icon-name name="share"></ark-lib-icon-name>
            <div
              class="text-black text-[11px] font-normal leading-[18px] ml-[5px]"
            >
              {{ item?.shareCount }}
            </div>
          </div>
        </div>
      </div>

      <div class="justify-start items-center gap-3 flex pt-[5px]" *ngIf="isIdea || isProblem">
        <div class="justify-between items-center gap-2 flex w-full">
          <div class="justify-center items-center gap-[3px] flex" *ngIf="item?.backedCount != null">
            <ark-lib-icon-name name="heart"></ark-lib-icon-name>
            <div class="text-black text-xs font-normal leading-tight">
              {{ item?.backedCount }}
            </div>
          </div>
          <div class="justify-center items-center gap-[3px] flex">
            <ark-lib-icon-name name="chat"></ark-lib-icon-name>
            <div class="text-black text-xs font-normal leading-tight">
              {{ item?.commentCount }}
            </div>
          </div>
          <div class="flex flex-row items-center" *ngIf="item?.shareCount != null">
            <ark-lib-icon-name name="share"></ark-lib-icon-name>
            <div
              class="text-black text-[11px] font-normal leading-[18px] ml-[5px]"
            >
              {{ item?.shareCount }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
